import React from 'react';
import { IProps } from './type';

const ArrowBackIcon = ({ cName, width, height, fillColor, strokeColor, viewBox, onClick }: IProps) => {
  return (
    <svg
      className={cName}
      width={width ? width : '24'}
      height={height ? height : '24'}
      viewBox={viewBox ? viewBox : '0 0 24 24'}
      fill={fillColor ? fillColor : 'none'}
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.68945 11.46L3.34748 11.0952L2.9584 11.46L3.34748 11.8247L3.68945 11.46ZM19.6895 11.96C19.9656 11.96 20.1895 11.7361 20.1895 11.46C20.1895 11.1838 19.9656 10.96 19.6895 10.96V11.96ZM8.68082 6.09519L3.34748 11.0952L4.03142 11.8247L9.36476 6.82473L8.68082 6.09519ZM3.34748 11.8247L8.68082 16.8247L9.36476 16.0952L4.03142 11.0952L3.34748 11.8247ZM3.68945 11.96H19.6895V10.96H3.68945V11.96Z"
        fill={fillColor ? fillColor : '#212121'} />
    </svg>
  )
};

export default ArrowBackIcon;
